import { useEffect, useState } from 'react';

// Minimal dependency-free toast. Any code can fire one with showToast(msg);
// a single <Toaster /> mounted in Layout renders + auto-dismisses them.
// Used today for the "not enabled yet" click-blocks on gated features.

let idSeq = 0;
const listeners = new Set();

export function showToast(message, opts = {}) {
  const toast = { id: (idSeq += 1), message, duration: opts.duration ?? 2400 };
  listeners.forEach((fn) => fn(toast));
}

export default function Toaster() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    function onToast(toast) {
      setToasts((cur) => [...cur, { ...toast, leaving: false }]);
      // Flip to leaving → CSS opacity transition fades it out.
      setTimeout(() => {
        setToasts((cur) => cur.map((t) => (t.id === toast.id ? { ...t, leaving: true } : t)));
      }, toast.duration);
      // Remove from the DOM once the fade has finished.
      setTimeout(() => {
        setToasts((cur) => cur.filter((t) => t.id !== toast.id));
      }, toast.duration + 320);
    }
    listeners.add(onToast);
    return () => listeners.delete(onToast);
  }, []);

  if (!toasts.length) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] flex flex-col items-center gap-2 pointer-events-none">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`pointer-events-auto animate-fade-in-up px-4 py-2.5 rounded-xl bg-gray-900/90 dark:bg-gray-800/95 text-white text-sm font-medium shadow-lg backdrop-blur-sm border border-white/10 transition-all duration-300 ${
            t.leaving ? 'opacity-0 translate-y-1' : 'opacity-100 translate-y-0'
          }`}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
